(function () {
  function normalizeTag(tag) {
    return String(tag || '')
      .trim()
      .toLowerCase();
  }

  function parseTags(raw) {
    if (!raw) return [];
    return raw
      .split('|')
      .map(normalizeTag)
      .filter(Boolean);
  }

  class FieldNotesBlog {
    constructor(root) {
      this.root = root;
      this.featured = root.querySelector('[data-td-fn-featured]');
      this.grid = root.querySelector('[data-td-fn-grid]');
      this.tabs = [...root.querySelectorAll('[data-td-fn-tab]')];
      this.catalog = root.querySelector('[data-td-fn-catalog]');
      this.posts = this.catalog
        ? [...this.catalog.querySelectorAll('[data-td-fn-post]')]
        : [];
      this.activeTag = 'all';

      if (!this.featured || !this.grid || !this.posts.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tag = tab.dataset.tdFnTab || 'all';
          if (tag === this.activeTag) return;
          this.activeTag = tag;
          this.setActiveTab(tab);
          this.render();
        });
      });

      this.render();
    }

    setActiveTab(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    getVisiblePosts() {
      if (this.activeTag === 'all') return this.posts;

      return this.posts.filter((post) => {
        const tags = parseTags(post.dataset.tags);
        return tags.includes(this.activeTag);
      });
    }

    render() {
      const visible = this.getVisiblePosts();

      this.featured.innerHTML = '';
      this.grid.innerHTML = '';

      if (!visible.length) {
        this.featured.hidden = true;
        this.root.classList.remove('is-single-result');
        this.grid.innerHTML = '<p class="td-fn__empty">No articles in this category yet.</p>';
        return;
      }

      this.featured.hidden = false;
      this.root.classList.toggle('is-single-result', visible.length === 1);

      const featuredVariant = visible[0].querySelector('[data-td-fn-variant="featured"]');
      if (featuredVariant?.firstElementChild) {
        this.featured.appendChild(featuredVariant.firstElementChild.cloneNode(true));
      }

      visible.slice(1).forEach((post) => {
        const cardVariant = post.querySelector('[data-td-fn-variant="card"]');
        if (cardVariant?.firstElementChild) {
          this.grid.appendChild(cardVariant.firstElementChild.cloneNode(true));
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-td-field-notes]').forEach((root) => {
      if (root.dataset.tdFnReady) return;
      root.dataset.tdFnReady = 'true';
      new FieldNotesBlog(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
